import { useEffect } from 'react';
import type { ShowcaseUpsellAction } from './showcaseActions';

/** True when a drag carries files from the computer (not a clip card of the panel). Pure. */
export function isFileDrag(types: ArrayLike<string> | undefined): boolean {
  return types !== undefined && Array.from(types).includes('Files');
}

/**
 * The showcase has no upload (design c3): a file dropped anywhere on the editor opens the sign-up
 * card with the upload line, and the browser does not open the file in the tab.
 */
export function useShowcaseFileDrop(showUpsell: (action: ShowcaseUpsellAction) => void): void {
  useEffect(() => {
    const onDragOver = (event: DragEvent) => {
      if (isFileDrag(event.dataTransfer?.types)) {
        event.preventDefault();
      }
    };
    const onDrop = (event: DragEvent) => {
      if (!isFileDrag(event.dataTransfer?.types)) {
        return;
      }
      event.preventDefault();
      showUpsell('upload');
    };
    window.addEventListener('dragover', onDragOver);
    window.addEventListener('drop', onDrop);
    return () => {
      window.removeEventListener('dragover', onDragOver);
      window.removeEventListener('drop', onDrop);
    };
  }, [showUpsell]);
}
